import React from 'react';

import { Divider } from '../../../layout/public';

/*** Separates adjacent items in a vertical native list. */
export function VerticalListSeparator() {
  return <Divider orientation="horizontal" />;
}
